


export default {
    home_menus: [
        { name: "編號", id: "id" },
        { name: "名稱", id: "title" },
        { name: "分類", id: "name" },
        { name: "排序", id: "sort" },
        { name: "時間", id: "create_time" }
    ],
    
}